import { CursorClickIcon } from "@heroicons/react/solid";
import { Modal } from "@ui/components/modal";
import Link from "next/link";

export interface BlockerModalProps {
  open: boolean;
  setOpen: (val: boolean) => void;
  gym?: string;
}

export function BlockerModal(props: BlockerModalProps) {
  return (
    <Modal
      title="Free Plan Limit Reached"
      size="xs"
      open={props.open}
      setOpen={props.setOpen}
      hideHeader={true}
    >
      <Modal.Content>
        <div className="text-center">
          <h3 className="text-foreground mb-2 text-2xl font-semibold">Upgrade your plan</h3>
          <p className="text-muted-foreground">
            To send more messages per month you need to upgrade your plan.
          </p>
        </div>
      </Modal.Content>
      <Modal.Footer>
        <div className="flex flex-col space-y-3">
          <Link
            href={`/settings/inboxes/${props.gym}/subscription`}
            onClick={() => props.setOpen(false)}
            className="btn btn--xl btn--green btn--semibold"
          >
            Choose a plan
            <CursorClickIcon className="w-5 h-5 ml-1" />
          </Link>
          <a
            onClick={() => props.setOpen(false)}
            className="inline-block text-xs text-center text-muted-foreground cursor-pointer"
          >
            No thanks, I will wait until next month.
          </a>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
